export default __webpack_public_path__ + "static/media/Image.b25b7d14.png";